
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.8 18.1l-.9-.9-2.9 2.9-2.9-2.9-.9.9 2.9 2.9-2.9 2.9.9.9 2.9-2.9 2.9 2.9.9-.9-2.9-2.9 2.9-2.9zM8.4 10.2a1.8 1.8 0 100-3.6 1.8 1.8 0 000 3.6zm4.9 0a1.8 1.8 0 100-3.6 1.8 1.8 0 000 3.6z","fill":"#F9A91E"}}),_c('path',{attrs:{"d":"M29.8 3.3H4.3c-.6 0-1 .4-1 1v25.5c0 .6.4 1 1 1h25.5c.6 0 1-.4 1-1V4.3c0-.6-.4-1-1-1zm-1 2v5.9H5.3V5.3h23.5zm-4 15.7c0 4.3-3.5 7.8-7.8 7.8S9.2 25.3 9.2 21s3.5-7.8 7.8-7.8 7.8 3.5 7.8 7.8zM5.3 28.8V13.2h5.8C8.7 15 7.2 17.8 7.2 21s1.5 6 3.9 7.8H5.3zm17.6 0c2.4-1.8 3.9-4.6 3.9-7.8s-1.5-6-3.9-7.8h5.9v15.6h-5.9z","fill":"#47AEA6"}})])
          )
        }
      }
    